import { render, staticRenderFns } from "./textMessageSetting.vue?vue&type=template&id=6c1aead9&scoped=true&"
import script from "./textMessageSetting.vue?vue&type=script&lang=js&"
export * from "./textMessageSetting.vue?vue&type=script&lang=js&"
import style0 from "./textMessageSetting.vue?vue&type=style&index=0&id=6c1aead9&prod&lang=scss&"
import style1 from "./textMessageSetting.vue?vue&type=style&index=1&id=6c1aead9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1aead9",
  null
  
)

export default component.exports